<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
            <div class="title-box"><span class="txt1">基础信息</span></div>
            <el-alert class="activity-stack-notice" title="同一商品满足多个活动时，各活动奖励叠加。" type="info" :closable="false" show-icon />
            <el-form-item label="活动名称：" prop="activityName">
              <el-input v-model="form.activityName" placeholder="请输入活动名称" maxlength="16" show-word-limit />
            </el-form-item>
            <el-form-item label="聚水潭标签：" prop="jstLabel">
              <el-input v-model="form.jstLabel" placeholder="推送聚水潭的订单标签，选填" maxlength="10" show-word-limit />
              <div class="form-tip">聚水潭限制最多10个字；不填则推单不带活动标签</div>
            </el-form-item>
            <el-form-item label="活动方式：" prop="activityWay">
              <el-select v-model="form.activityWay" placeholder="请选择" clearable size="small">
                <el-option label="平台满赠" :value="2"></el-option>
                <el-option label="指定商品" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否限制时间：" prop="timeLimit">
              <el-radio-group v-model="form.timeLimit">
                <el-radio :label="0">不限制</el-radio>
                <el-radio :label="1">限制</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="活动时间：" prop="dateTime" v-if="form.timeLimit">
              <el-date-picker v-model="form.dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="时间状态：" class="width100">
              <time-status :time-limit="form.timeLimit" :start-time="form.dateTime && form.dateTime[0]" :end-time="form.dateTime && form.dateTime[1]" :now="now" :activity-status="form.activityStatus" show-listing show-period />
            </el-form-item>
            <el-form-item label="活动规则：" prop="activityRule" class="width100">
              <el-input v-model="form.activityRule" placeholder="请输入规则" maxlength="32" show-word-limit />
            </el-form-item>
            <el-form-item label="参与活动身份：" class="is-required width100">
              <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in options.customerLevelList" :key="index" @click="handleActive(item)">
                <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
              </div>
            </el-form-item>
            <el-form-item label="参与活动条件：" prop="activityModules" required class="width100">
              <button type="button" class="lab selection-button" :class="{'active': item.isActive}" v-for="item in activeCondition" :key="item.key" :aria-pressed="!!item.isActive" @click="handleActiveModule(item)">
                <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
              </button>
              <div class="hint hint1">决定活动出现在哪个商城。</div>
            </el-form-item>
            <el-form-item label="参与付款方式：" prop="payModes" required class="width100">
              <button type="button" class="lab selection-button" :class="{'active': item.isActive}" v-for="item in payModeOptions" :key="item.key" :aria-pressed="!!item.isActive" :disabled="isPayModeDisabled(item.key)" @click="handleActivePayMode(item)">
                <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
              </button>
              <div class="hint hint1">
                决定客户用哪种付款方式下单才触发本活动，与上面的商城是两个维度：余额商城里的现金单和余额单，只有这里分得开。<br />
                新选商城会勾选对应付款方式，可按需取消；每个已选商城至少保留一种付款方式。灰色选项需先选择对应商城。<br />
                同一门槛按付款方式送不同数量（如现金满30送15、余额满30送10），需要建两个活动，付款方式分开勾选。
              </div>
            </el-form-item>
            <div class="title-box"><span class="txt1">活动商品</span></div>
            <el-form-item label="活动类型：" prop="activityType">
              <el-radio-group v-model="form.activityType">
                <el-radio :label="1">满件赠</el-radio>
                <el-radio :label="2">满金额赠</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="赠送方式：" prop="givingWay">
              <el-radio-group v-model="form.givingWay">
                <el-radio :label="1">平台随机赠送</el-radio>
                <el-radio :label="2">客户自选赠品</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否叠加赠送：" prop="activityCondition" class="width100">
              <el-radio-group v-model="form.activityCondition">
                <el-radio :label="0">不叠加</el-radio>
                <el-radio :label="1">叠加</el-radio>
              </el-radio-group>
              <div class="hint hint1">叠加时按达标次数赠送：例如满5件送1件，买10件或11件送2件；不叠加只送1件。</div>
            </el-form-item>
            <div v-for="(item,index) in form.conditionList" :key="index" class="full-box">
              <el-form-item label="满：" label-width="70px" class="cond-col" :prop="`conditionList[${index}].fullNum`" :rules="{validator: validateThreshold, trigger: ['blur', 'change']}">
                <el-input v-model="item.fullNum" placeholder="满多少金额/件">
                  <i slot="suffix" class="el-input__icon">{{Number(form.activityType) === 2 ? '元' : '件'}}</i>
                </el-input>
              </el-form-item>
              <el-form-item label="赠品类型：" label-width="110px" class="cond-col" :prop="`conditionList[${index}].rewardType`" :rules="{required: true,message: '请选择',trigger: 'change'}">
                <el-select v-model="item.rewardType" placeholder="请选择" @change="handleRewardTypeChange(item)">
                  <el-option v-for="it in rewardTypeOptions" :key="it.key" :label="it.value" :value="it.key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="!isVirtualReward(item.rewardType)" label="赠送：" label-width="70px" class="cond-col" :prop="`conditionList[${index}].giftNum`" :rules="{required: true,message: '请填写',trigger: 'change'}">
                <el-input v-model="item.giftNum" placeholder="赠送赠品数量" @input="handleGiftCandidatesChange">
                  <i slot="suffix" class="el-input__icon">件赠品</i>
                </el-input>
              </el-form-item>
              <el-form-item v-else label="赠送：" label-width="70px" class="cond-col" :prop="`conditionList[${index}].rewardValue`" :rules="rewardValueRules">
                <el-input v-model="item.rewardValue" placeholder="赠送数额">
                  <i slot="suffix" class="el-input__icon">{{rewardUnit(item.rewardType)}}</i>
                </el-input>
              </el-form-item>
              <div class="full-icon">
                <i class="el-icon-plus" @click="handleAddItem"></i>
                <i class="el-icon-minus" @click="handleDeleteItem(index)" v-if="form.conditionList.length > 1"></i>
              </div>
            </div>
            <div class="hint hint1">点击“＋”添加其他门槛规则。虚拟赠品在支付成功后发放到对应账户，无需选择实物赠品。</div>
            <el-form-item label="选择商品：" prop="sysGoodsList" v-if="form.activityWay === 1" class="width100">
              <el-select v-model="form.sysGoodsList" filterable multiple placeholder="请选择商品">
                <el-option v-for="item in options.sysGoods" :key="item.id" :label="item.codeAndName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="赠送商品：" prop="giftData" class="width100" :required="giftCandidateRequired" v-if="needGiftGoods">
              <div v-if="Number(form.givingWay) === 2" class="hint hint1">以下商品及规格是客户下单时可选的赠品范围，由客户在确认订单页选择；后台配置不会替客户选定最终赠品。</div>
              <gift-vue :form="form" :type="2" @gift-candidates-change="handleGiftCandidatesChange" />
            </el-form-item>
            <el-form-item label="状态：" class="width100">
              <el-switch v-model="form.activityStatus" :active-value="1" :inactive-value="0" @change="handleGiftCandidatesChange"></el-switch>{{form.activityStatus?'上架':'下架'}}
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div v-if="submitError" ref="submitErrorBox" class="save-error-box" role="alert" aria-live="polite">
          <i class="el-icon-warning-outline" aria-hidden="true"></i>
          <span>{{submitError}}</span>
          <el-button v-if="submitError.includes('赠品')" type="text" size="small" @click="scrollToGiftCandidates">去完善</el-button>
        </div>
        <el-button size="small" @click="formVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="isRepSub" @click="doCreate()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
import timeStatus from './timeStatus'
import { activityTimeState } from './activityTime'
import giftVue from '@/views/common/gift.vue'
import recommendGoodsVue from '@/views/common/recommendGoods.vue';
import customerLevelApi from '@/api/sys/customerLevel'
import goodsActivityApi from '@/api/goods/goodsActivity'
import {
  PAY_MODE_OPTIONS,
  REWARD_TYPE_GOODS,
  REWARD_TYPE_OPTIONS,
  fallbackPayModes,
  initialActivitySelection,
  toggleActivityModule,
  toggleActivityPayMode,
  activitySelectionErrors,
  isVirtualReward,
  rewardUnit,
  activityThresholdError
} from './activityEnum'
function validateRewardValue(rule, value, callback) {
  if (value === '' || value === null || value === undefined) {
    return callback(new Error('请填写赠送数额'))
  }
  const num = Number(value)
  if (isNaN(num) || num <= 0) {
    return callback(new Error('请填写大于0的数额'))
  }
  callback()
}
function initCondition() {
  return { fullNum: '', giftNum: '', rewardType: REWARD_TYPE_GOODS, rewardValue: null }
}
function initFormBean() {
  const formBean = {
    activityName: null,
    jstLabel: '',
    activityModules: '',
    payModes: '',
    activityWay: null,
    timeLimit: null,
    dateTime: null,
    activityRule: null,
    activityType: null,
    givingWay: null,
    activityCondition: null,
    sysGoodsList: [],
    conditionList: [initCondition()],
    giftData: [{ goodsId: '', specValuecombineId: '' }],
    activityStatus: 0,
    // 兼容旧字段。已有活动保留原值；多活动命中不再按此字段筛选奖励。
    priority: 0,
    // 版本号：编辑时由详情接口带回来，保存时原样回传给后端做并发冲突检测。
    // 新建时为 null，后端不校验。**不要在前端改这个值**，它由服务端自增。
    versionNo: null,
  }
  return formBean
}

export default {
  props: { now: { type: Number, required: true } },
  components: { giftVue, recommendGoodsVue, timeStatus },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        activityName: [{ required: true, whitespace: true, message: '请输入活动名称', trigger: 'blur' }],
        activityModules: [{ validator: this.validateActivitySelection, trigger: 'change' }],
        payModes: [{ validator: this.validateActivitySelection, trigger: 'change' }],
        activityRule: [{ max: 32, message: '活动规则不能超过32个字符', trigger: ['blur', 'change'] }],
        activityWay: [{ required: true, message: '请选择活动方式', trigger: 'change' }],
        timeLimit: [{ required: true, message: '请选择是否限制时间', trigger: 'change' }],
        dateTime: [{ required: true, message: '请选择活动时间', trigger: 'change' }, { validator: this.validateActivityTime, trigger: 'change' }],
        activityType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
        sysGoodsList: [{ required: true, message: '请选择商品', trigger: 'change' }],
        activityCondition: [{ required: true, message: '请选择是否叠加赠送', trigger: 'change' }],
        givingWay: [{ required: true, message: '请选择赠送方式', trigger: 'change' }],
        giftData: [{ validator: this.validateGiftCandidates, trigger: 'change' }],
      },
      options: {
        customerLevelList: [],
        sysGoods: []
      },
      isRepSub: false,
      submitError: '',
      activeCondition: [{ value: '余额商城', key: 1, isActive: false }, { value: '零售价商城', key: 2, isActive: false }, { value: '赠送额度商城', key: 3, isActive: false }],
      // 付款方式（goods_activity.pay_modes），与上面的活动模块是两个字段
      payModeOptions: PAY_MODE_OPTIONS.map(item => ({ ...item, isActive: false })),
      rewardTypeOptions: REWARD_TYPE_OPTIONS,
      rewardValueRules: [{ required: true, validator: validateRewardValue, trigger: 'change' }]
    }
  },
  computed: {
    /** 只要还有一条实物赠品条件，就得选赠送商品 */
    needGiftGoods() {
      const list = this.form.conditionList || []
      return list.length === 0 || list.some(item => !isVirtualReward(item.rewardType))
    },
    giftCandidateRequired() {
      return Number(this.form.activityStatus) === 1 && (this.form.conditionList || [])
        .some(item => !isVirtualReward(item.rewardType) && Number(item.giftNum) > 0)
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = Math.max(280, windowHeight - 220);
    this.getCustomerLevel()
    this.getGoods();
  },
  methods: {
    validateActivitySelection(rule, value, callback) {
      const message = activitySelectionErrors(this.form.activityModules, this.form.payModes)[rule.field]
      callback(message ? new Error(message) : undefined)
    },
    applyActivitySelection(selection, validate = true) {
      this.activeCondition.forEach(item => { item.isActive = selection.modules.indexOf(String(item.key)) > -1 })
      this.payModeOptions.forEach(item => { item.isActive = selection.payModes.indexOf(item.key) > -1 })
      this.form.activityModules = this.calcJurisd(this.activeCondition).join(',')
      this.form.payModes = this.calcJurisd(this.payModeOptions).join(',')
      if (validate) this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.validateField(['activityModules', 'payModes'])
      })
    },
    isPayModeDisabled(key) {
      return fallbackPayModes(this.form.activityModules).indexOf(key) === -1
    },
    validateGiftCandidates(rule, value, callback) {
      if (!this.giftCandidateRequired) return callback()
      const validSku = Array.isArray(value) && value.some(item => item &&
        Number.isInteger(Number(item.goodsId)) && Number(item.goodsId) > 0 &&
        Number.isInteger(Number(item.specValuecombineId)) && Number(item.specValuecombineId) > 0)
      callback(validSku ? undefined : new Error('请配置候选赠品，至少选择一个赠送商品及有效规格'))
    },
    handleGiftCandidatesChange() {
      const dataForm = this.$refs.dataForm
      if (!dataForm) return
      if (this.needGiftGoods) dataForm.validateField('giftData')
      else dataForm.clearValidate('giftData')
    },
    validateActivityTime(rule, value, callback) {
      if (Number(this.form.timeLimit) !== 1) return callback()
      const state = activityTimeState(1, value && value[0], value && value[1], this.now)
      callback(state.key === 'invalid' ? new Error(state.hint) : undefined)
    },
    validateThreshold(rule, value, callback) {
      const message = activityThresholdError(value, this.form.activityType)
      callback(message ? new Error(message) : undefined)
    },

    getGoods() {
      sysGoodsApi.getGoodRecomList().then(({ data }) => {
        data.forEach(item => {
          // REQ-2026-234328：选参与活动的商品时也要看得到规格（赠品侧早就有了，
          // 正价商品这侧一直没有）。同名不同规格的商品在这个下拉里**只靠名字分不出来**，
          // 运营挑错一个，整场活动的参与商品就错了。
          // 接口本来就返回 productSpec（/getConfigList → SysGoodsConfigListVO），
          // **不用改后端**，之前只是没显示。
          const spec = (item.productSpec || '').trim()
          item.codeAndName = spec
            ? `${item.goodsCode} ${item.name}（${spec}）`
            : `${item.goodsCode} ${item.name}`
        });
        this.options.sysGoods = data
      })
    },
    getCustomerLevel() {
      customerLevelApi.fetchList().then(({ data }) => {
        let arr = []
        data.forEach(item => {
          arr.push({ value: item.name, key: item.id })
        })
        //处理 参与活动身份只有体验班、研修班
        const neededIds = [6, 7];
        arr = arr.filter(obj => neededIds.includes(obj.key));
        this.options.customerLevelList = arr;
      })
    },
    handleActive(item) {
      item.isActive = !item.isActive
      this.$forceUpdate();
    },
    isVirtualReward,
    rewardUnit,
    handleActiveModule(item) {
      this.applyActivitySelection(toggleActivityModule(this.form.activityModules, this.form.payModes, item.key))
    },
    handleActivePayMode(item) {
      if (this.isPayModeDisabled(item.key)) return
      this.applyActivitySelection(toggleActivityPayMode(this.form.activityModules, this.form.payModes, item.key))
    },
    /**
     * 赠品类型切换。
     * 虚拟币赠品不选实物 SKU，但 gift_num 仍要落 0 ——
     * APP 端结算时对命中条件按 giftNum 排序，null 会直接 NPE。
     */
    handleRewardTypeChange(item) {
      if (isVirtualReward(item.rewardType)) {
        this.$set(item, 'giftNum', 0)
      } else {
        this.$set(item, 'rewardValue', null)
        if (!item.giftNum) this.$set(item, 'giftNum', '')
      }
      this.$nextTick(this.handleGiftCandidatesChange)
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.submitError = ''
      this.form = initFormBean()
      this.options.customerLevelList.forEach(item => {
        item.isActive = false
      })
      this.activeCondition.forEach(item => {
        item.isActive = false
      })
      this.payModeOptions.forEach(item => {
        item.isActive = false
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...initFormBean(), ...row }
      this.calcEditData()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcEditData() {
      let { startTime, endTime, customerLevelList, activityModules, payModes, sysGoodsSpecValuecombineList, activityConditionList, sysGoodsList } = this.form;
      //活动时间
      if (startTime && endTime) this.$set(this.form, 'dateTime', [startTime, endTime]);
      else this.$set(this.form, 'dateTime', []);
      //参与活动身份
      this.options.customerLevelList.forEach(item => {
        let find = customerLevelList.find(it => it.id === item.key)
        item.isActive = find ? true : false
      })
      // 仅打开旧空值记录时回显一次；保存始终显式提交，已有合法子集不覆盖。
      this.applyActivitySelection(initialActivitySelection(activityModules, payModes), false)
      //赠送商品
      let arr = []
      if (sysGoodsSpecValuecombineList.length > 0) {
        sysGoodsSpecValuecombineList.forEach(item => {
          arr.push({ goodsId: item.productId, specValuecombineId: item.id })
        })
      }
      if (arr.length > 0) this.$set(this.form, 'giftData', arr);
      else this.$set(this.form, 'giftData', [{ goodsId: '', specValuecombineId: '' }]);

      //活动条件
      activityConditionList && activityConditionList.map(it => {
        delete it.createdTime
        // 存量条件没有 reward_type，统一按实物赠品显示（与后端 normalizeReward 一致）
        if (!it.rewardType) it.rewardType = REWARD_TYPE_GOODS
      })

      this.$set(this.form, 'conditionList', activityConditionList && activityConditionList.length > 0 ? activityConditionList : [initCondition()]);
      delete this.form.activityConditionList
      //选择商品
      this.$set(this.form, 'sysGoodsList', sysGoodsList.map(obj => obj.id));
    },
    calcJurisd(forArr) {
      let arr = []
      forArr.forEach(item => {
        if (item.isActive) arr.push(item.key)
      })
      return arr
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      if (params.timeLimit) {
        params.startTime = params.dateTime && params.dateTime.length > 0 ? params.dateTime[0] : ''
        params.endTime = params.dateTime && params.dateTime.length > 0 ? params.dateTime[1] : ''
      } else {
        params.startTime = ''
        params.endTime = ''
      }
      delete params.dateTime
      params.customerLevelList = this.calcJurisd(this.options.customerLevelList)
      params.activityName = String(params.activityName || '').trim()
      params.jstLabel = String(params.jstLabel || '').trim()
      // 赠品类型：reward_type 是 NOT NULL，一律显式带上
      params.conditionList = (params.conditionList || []).map(item => {
        const condition = { ...item }
        condition.rewardType = condition.rewardType || REWARD_TYPE_GOODS
        if (isVirtualReward(condition.rewardType)) {
          // 虚拟币赠品不发实物，但 gift_num 得有值：APP 端按 giftNum 排序命中条件
          condition.giftNum = 0
        } else {
          condition.rewardValue = null
        }
        return condition
      })
      return params
    },
    checkPayModes(params) {
      const errors = activitySelectionErrors(params.activityModules, params.payModes)
      return errors.activityModules || errors.payModes || null
    },
    showSubmitError(message, invalidFields) {
      // 表单校验由字段自身展示，避免顶部大警示和字段错误重复。
      this.submitError = invalidFields ? '' : message
      if (invalidFields) {
        this.$nextTick(() => {
          const dataForm = this.$refs.dataForm
          const first = dataForm && dataForm.fields.find(field => invalidFields[field.prop])
          if (first && first.$el) first.$el.scrollIntoView({ block: 'center' })
        })
      }
      else this.revealSubmitError()
    },
    revealSubmitError() {
      this.$nextTick(() => {
        const box = this.$refs.submitErrorBox
        if (box) box.scrollIntoView({ block: 'center' })
      })
    },
    scrollToGiftCandidates() {
      const dataForm = this.$refs.dataForm
      const field = dataForm && dataForm.fields.find(item => item.prop === 'giftData')
      if (field && field.$el) field.$el.scrollIntoView({ block: 'center' })
    },
    doCreate() {
      if (this.isRepSub) return this.showSubmitError('正在保存，请等待结果')
      this.submitError = ''
      this.form.activityName = String(this.form.activityName || '').trim()
      const dataForm = this.$refs.dataForm
      if (!dataForm) return this.showSubmitError('表单尚未就绪，请稍后重试')
      try {
        dataForm.validate((valid, invalidFields) => {
          if (!valid) {
            const giftError = invalidFields && invalidFields.giftData && invalidFields.giftData[0]
            return this.showSubmitError(giftError ? giftError.message : '请检查并完善标红的活动配置', invalidFields)
          }
          try {
            let params = this.calcParams()
            if (!params.customerLevelList.length) return this.showSubmitError('请选择参与活动身份')
            if (!params.activityModules) return this.showSubmitError('请选择参与活动条件')
            const payModeError = this.checkPayModes(params)
            if (payModeError) return this.showSubmitError(payModeError)
            if (params.id) {
              params.conditionList.forEach(item => item.activityId = params.id)
            }
            params.sysGoodsSpecValuecombineList = this.needGiftGoods
              ? params.giftData.map(obj => obj.specValuecombineId).filter(id => !!id)
              : []
            this.submitGoods(params)
          } catch (error) {
            this.showSubmitError('活动配置处理失败，草稿已保留，请重试')
          }
        })
      } catch (error) {
        this.showSubmitError('活动配置校验失败，草稿已保留，请重试')
      }
    },
    submitGoods(params) {
      delete params.giftData
      if (this.isRepSub) return this.showSubmitError('正在保存，请等待结果')
      this.isRepSub = true
      if (params.id > 0) {
        delete params.operatedTime
        delete params.operatedPeople
        goodsActivityApi.update(params).then((data) => {
          this.postCallback(data)
        }).catch(this.showSaveError);
      } else {
        goodsActivityApi.create(params).then((data) => {
          this.postCallback(data)
        }).catch(this.showSaveError);
      }
    },
    showSaveError(error) {
      this.isRepSub = false
      const data = error && error.response && error.response.data
      const detail = data && (data.errorMessage || data.message)
      const readable = typeof detail === 'string' && detail.trim()
      const internalError = readable && /系统内部错误|服务器内部错误|Internal Server Error|Exception|SQL/i.test(readable)
      this.submitError = readable && !internalError
        ? readable
        : error && error.response
          ? '服务暂时无法保存活动，请稍后重试；如果再次失败，请联系管理员处理。'
          : '未收到保存结果，请检查网络；恢复后先确认活动是否已保存，再重试。'
      this.revealSubmitError()
    },
    postCallback(data) {
      this.isRepSub = false
      this.formVisible = false;
      this.$emit('created')
      // conflictTip 说明参与商品与其它启用中的活动重叠；允许保存，满足的活动奖励叠加。
      // 用弹窗而不是 toast：toast 会自动消失，运营很可能没看见就走了，
      // 而这条信息会影响他后续怎么配活动。
      const tip = data && data.data && data.data.conflictTip
      if (tip) {
        this.$alert(tip, '保存成功，说明一下规则怎么生效', {
          confirmButtonText: '知道了',
          type: 'warning'
        }).catch(() => {})
      } else {
        this.$message.success('操作成功')
      }
    },
    handleDeleteItem(index) {
      this.form.conditionList.splice(index, 1)
    },
    handleAddItem() {
      this.form.conditionList.push(initCondition())
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.form-tip {
  font-size: 12px;
  line-height: 20px;
  color: #909399;
}
.activity-stack-notice {
  width: 97%;
  margin: 0 0 16px;
}
.save-error-box {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 6px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 20px;
  text-align: left;
  overflow-wrap: anywhere;
  > i, > .el-button { flex-shrink: 0; }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
::v-deep .el-dialog__footer {
  padding: 0;
}
.reimbursement {
  padding-bottom: 12px;
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 47%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.lab {
  font-size: 14px;
  color: #8f8e8e;
  border-radius: 4px;
  padding: 0 18px;
  display: inline-block;
  border: 1px solid #c5c5c5;
  margin: 5px;
  position: relative;
  cursor: pointer;
  &.active {
    background: #5dbde7;
    color: #fff;
    border-color: #5dbde7;
  }
  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.selection-button {
  background: #fff;
  font-family: inherit;
  line-height: 30px;
  &:focus-visible {
    outline: 2px solid #409eff;
    outline-offset: 2px;
  }
  &:disabled {
    color: #c0c4cc;
    background: #f5f7fa;
    border-color: #e4e7ed;
    cursor: not-allowed;
  }
}
.full-box {
  display: flex;
  // 一行三列：满 / 赠品类型 / 赠送数量或数额
  .el-form-item--small.el-form-item.cond-col {
    width: 31%;
  }
  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;
    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
</style>
